/**
 * Brazilian Portuguese (pt-BR) mappings for UnifiedNavHeader
 * Simple key-value pairs for easy maintenance
 */

export const unifiedNavHeaderPtBR = {
  // Navigation labels
  "Home": "Início",
  "Sports Hub": "Central de Esportes",

  // Button labels
  "Chat with AI": "Conversar com IA",

  // Additional navigation items that might be used
  "Back": "Voltar",
  "Menu": "Menu",
  "Close": "Fechar"
};
